import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicCreerCategorie = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;
  
  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Gestion de votre compétition', link: '/topics/gestion-compet'},
    { label: "Général", link: '/topics/gestion-compet/general'}, 
    { label: topic.title, link: topic.link},
  ]

  // <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/app/dashboard`}>dashboard</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Depuis votre espace
              <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/app/dashboard`}>admin,</a> 
              cliquez sur l'onglet <strong>Catégories.</strong><br/>
              Le formulaire s'ouvrira automatiquement. Sinon cliquez simplement sur le bouton <strong>Créer une catégorie</strong>
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                C'est ici que vous configurez les informations clés pour une nouvelle catégorie. 
                Indiquez son nom, le nombre d'athlètes par équipe (mettez "1" pour une catégorie individuelle), 
                le tarif d'inscription, ainsi que le nombre de places disponibles.
              </p>
              <p className="help-text">
                Si vous ne souhaitez pas limiter les inscriptions, il vous suffit de cocher la case <strong>Place illimitées.</strong>
              </p>
              <p className="help-text">
                <strong className="mr-8">Autoriser les athlètes à choisir cette catégorie :</strong>
                Activez cette option pour laisser vos athlètes s'inscrire directement dans cette catégorie (active par défaut). 
                Décochez-la seulement si vous souhaitez faire un
                <a target='_blank' className="link" href={`#`}>Tri au ranking.</a> Dans ce cas là, cette catégorie ne sera pas 
                visible lors de l'inscription des athètes.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <ul>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <strong>Peux adapter le niveau (RX, Scale, Foundation) : </strong>
                    Cette option vous permet d'ouvrir votre compétition à tous les niveaux, à l'image des Opens.<br/>
                    Les athlètes peuvent adapter certains mouvements, poids du WOD. Ainsi, ils seront classés après les autres : 
                    les RX en tête par défaut, suivis des Scaled (S) et enfin des Foundation (F).
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <strong>Classement par point : </strong>
                    Vous avez la possibilité de classer vos athlètes soit de manière décroissante (par défaut), 
                    où le participant avec le plus de points est le leader, soit de manière croissante, où celui avec 
                    le moins de points remporte la compétition.
                  </p>
                </li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part">{anchorsParts[2].content}</p>
              <p className="help-text">
                Bien que l'affichage des standards de la catégorie soit optionnel, <strong>il est fortement recommandé. </strong> 
                Cela apporte une meilleure clarté et est grandement apprécié par vos athlètes. Les afficher 
                lors de l'inscription améliore leur expérience utilisateur et renforce leur confiance en votre organisation.
              </p>
              <p className="help-text">
                Vous pouvez le faire de deux manières : 
              </p>
              <ul>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <strong className="mr-8">En important une image : </strong>
                    Option la plus conseillée : utilisez la même image que celle 
                    de vos réseaux. Une image impactante reflète instantanément l’identité de votre compétition et attire l’attention.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <strong className="mr-8">En saisissant le text de vos standards : </strong>
                    utilisez notre générateur de texte pour présenter clairement et efficacement les standards de la catégorie.
                  </p>
                </li>
              </ul>
            </div>
            <div className="article-container mt-56">
              <p className="help-text">
                Une fois tous les champs renseignés, cliquez sur le bouton <strong>Créer la catégorie</strong>.
              </p>
              <p className="help-text">
                Pour modifier une catégorie déjà créée, cliquez simplement sur son nom dans la barre latérale, 
                apportez les ajustements nécessaires, puis cliquez sur le bouton <strong>Enregistrer</strong>.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicCreerCategorie